import { FormInstance, Row } from "antd";
import { FloatNumberInput } from "../../../../../../../components/FloatNumberInput";
import { Rule } from "antd/es/form";
import { useMemo } from "react";
import { useSelectValue } from "../../../../../../../lib/hooks/useSelectValue";

type DaysInputProps = {
  form: FormInstance;
  name: string;
};

export const DaysInput = ({ form, name }: DaysInputProps) => {
  const rules: Rule[] = useMemo(() => {
    return [
      () => ({
        validateTrigger: "onSubmit",
        validator(_: Rule, value: string) {
          if (!value || +value === 0) {
            return Promise.reject(new Error(""));
          }
          return Promise.resolve();
        },
      }),
    ];
  }, []);

  const { ref } = useSelectValue(true);

  return (
    <Row className="align-center">
      <FloatNumberInput
        className="days-input d-flex justify-center mb-0 ml-2"
        name={name}
        label=""
        prefix=""
        allowDecimal={false}
        form={form}
        rules={rules}
        customRef={ref}
      />
      <span className="text-sm title ml-1">days</span>
    </Row>
  );
};
